import { Ratio } from '@24i/nxg-sdk-higgs';
import { getTelegramWebApp, isWebMobile } from '@24i/nxg-sdk-higgs/src/utils';
import { sidebarConfig } from '../../../../../utils/constants';
import { SidebarStyles } from '../types';

const getStyles = (theme: any): SidebarStyles => ({
    list: {
        ...theme.sidebar.container,
        width:
            !!getTelegramWebApp() && isWebMobile()
                ? Ratio(sidebarConfig.sidebarWidthMobile)
                : theme.sidebar.container.width,
        position: 'relative',
        overflow: 'hidden',
        zIndex: 25,
    },
    channelCellContainer: {
        display: 'flex',
        marginHorizontal: Ratio(25),
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
        '@media (min-width: 801px) and (max-width: 1200px)': {
            marginLeft: 32,
        },
        '@media (min-width: 1201px)': {
            marginLeft: 48,
        },
    },
    text: {
        ...theme.sidebar.text,
    },
    logo: {
        ...theme.sidebar.logo,
        objectFit: 'contain',
        maxHeight: theme.cell.height,
    },
});

export default getStyles;
